/**
 * Formatadores locais da feature de assinatura (o portal não tem helper de moeda
 * com centavos nem de data). Valores de fatura precisam dos centavos.
 */
const money = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const date = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });

/** Valor em reais (ex.: 149 → "R$ 149,00"). */
export function formatMoney(reais: number): string {
  return money.format(reais);
}

/** Data ISO (ou YYYY-MM-DD) → dd/mm/aaaa. */
export function formatDate(iso: string): string {
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(d.getTime()) ? iso : date.format(d);
}
